import { Controller } from "@hotwired/stimulus"

export default class FilePreviewController extends Controller {
  static targets = ["input", "image"]
  static values = { originalUrl: String, filled: Boolean }

  #objectUrl = null

  show() {
    const file = this.inputTarget.files[0]

    this.#setImage(file ? URL.createObjectURL(file) : this.originalUrlValue)
  }

  clear() {
    this.inputTarget.value = ""
    this.#setImage("")
  }

  disconnect() {
    this.#revokeObjectUrl()
  }

  #setImage(url) {
    this.#revokeObjectUrl()
    if (url.startsWith("blob:")) this.#objectUrl = url

    if (url) {
      this.imageTarget.src = url
    } else {
      this.imageTarget.removeAttribute("src")
    }

    this.filledValue = Boolean(url)
  }

  #revokeObjectUrl() {
    if (this.#objectUrl) URL.revokeObjectURL(this.#objectUrl)
    this.#objectUrl = null
  }
}
